// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

// export const API_URL = 'http://104.131.19.126';
// export const API_URL = 'https://dev-tales.octacomm.mx';
export const API_URL = 'https://tales.octacomm.mx';
// export const API_URL = 'http://localhost:7878/';
